import { FaBell, FaExclamationTriangle } from 'react-icons/fa';
import { IoIosWarning } from 'react-icons/io';
export var BannerType;
(function (BannerType) {
    BannerType[BannerType["Warning"] = 0] = "Warning";
    BannerType[BannerType["Default"] = 1] = "Default";
    BannerType[BannerType["Info"] = 2] = "Info";
})(BannerType || (BannerType = {}));
export function getBackgroundClass(type) {
    switch (type) {
        case BannerType.Warning:
            return 'bg-amber-100';
        case BannerType.Info:
            return 'bg-yellow-200';
        default:
            return 'bg-oncolensOrange-200';
    }
}
export function getIconColor(type) {
    switch (type) {
        case BannerType.Warning:
            return 'text-yellow-500';
        case BannerType.Info:
            return 'text-gray-800';
        default:
            return 'text-oncolensOrange-500';
    }
}
export function getIcon(type) {
    switch (type) {
        case BannerType.Warning:
            return FaExclamationTriangle;
        case BannerType.Info:
            return IoIosWarning;
        default:
            return FaBell;
    }
}
export function getBorder(type) {
    switch (type) {
        case BannerType.Info:
            return 'border border-yellow-400 rounded-md';
        default:
            return '';
    }
}
